'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ClockCircleOutlined = _interopRequireDefault(require('./lib/icons/ClockCircleOutlined'));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _default = _ClockCircleOutlined;
exports.default = _default;
module.exports = _default;